//Möchten Sie wirklich die Akte neu anlegen?

import { Component, inject, Input, input } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";

@Component({
  selector: 'ngbd-modal-confirm-autofocus',
  template: `
		<div class="modal-header">
			<h4 class="modal-title" id="modal-title">{{Caption}}</h4>
			<button
				type="button"
				class="btn-close"
				aria-label="Close button"
				aria-describedby="modal-title"
				(click)="modal.dismiss(false)"
			></button>
		</div>
		<div class="modal-body">
			{{Text}}
		</div>
		<div class="modal-footer">
    	<button type="button" ngbAutofocus class="btn btn-success" (click)="modal.close(true)">Ja</button>
			<button type="button" class="btn btn-danger" (click)="modal.dismiss(false)">Nein</button>	
		</div>
	`,
})
export class ConfirmDialog {
  readonly modal = inject(NgbActiveModal);
  @Input() Text: string = "";
  @Input() Caption: string = "Bitte bestätigen!";
}
